// redux
import { combineReducers, createStore } from 'redux';
import { devToolsEnhancer } from 'redux-devtools-extension';
// reducers
import LAYOUT from './Layout';
import LOGIN from './Login';
import SHARE_DATA from './sharedata';
import SYSTEM_CODE from './systemCode';
import REL from './Projcet/REL';
import PAY from './Projcet/PAY';
import INQ from './Projcet/INQ';
import ADV from './Projcet/ADV';
var rootReducer = combineReducers({
    LAYOUT: LAYOUT,
    LOGIN: LOGIN,
    SHARE_DATA: SHARE_DATA,
    REL: REL,
    PAY: PAY,
    INQ: INQ,
    ADV: ADV,
    SYSTEM_CODE: SYSTEM_CODE,
});
var store = createStore(rootReducer, devToolsEnhancer({}));
export default store;
